var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 44,
    viewBox: "0 0 39 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 281"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 386",
    cx: 17.3134,
    cy: 17.1331,
    r: 13.8032,
    transform: "rotate(-7.25467 17.3134 17.1331)",
    stroke: "#C4C4C4",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 119",
    d: "M26.4316 27.3896L37.5495 39.195",
    stroke: "#C4C4C4",
    strokeWidth: 2.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.63819d86ac6fa05d5409a8a91c8760a9.svg";
export { ForwardRef as ReactComponent };